import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-da507a12")
const _hoisted_1 = { class: "origin-plastic-source-container" }
const _hoisted_2 = {
  key: 0,
  class: "environment-card"
}
const _hoisted_3 = { class: "title laget-font" }
const _hoisted_4 = { class: "environment-content" }
const _hoisted_5 = {
  key: 0,
  class: "environment-item"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "right-content litt-font" }
const _hoisted_8 = { class: "font1" }
const _hoisted_9 = { class: "font2" }
const _hoisted_10 = { class: "more" }
const _hoisted_11 = {
  key: 1,
  class: "other-card"
}
const _hoisted_12 = { class: "title medi-font" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "logo" }, [
  /*#__PURE__*/_createElementVNode("img", { src: "https://qnui.xfarmer.com/xfarmer-ui/trace/720@2x.png" })
], -1)
const _hoisted_15 = {
  key: 2,
  class: "other-card"
}
const _hoisted_16 = { class: "title medi-font" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "logo" }, [
  /*#__PURE__*/_createElementVNode("img", { src: "https://qnui.xfarmer.com/xfarmer-ui/trace/监控@2x.png" })
], -1)
const _hoisted_19 = {
  key: 3,
  class: "other-card"
}
const _hoisted_20 = { class: "title medi-font" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = ["id"]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_list = _resolveComponent("van-list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_list, { class: "content-wrap" }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countList, (item) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: item.id
          }, [
            (item.sortType == 3)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("span", null, _toDisplayString(item.name), 1)
                  ]),
                  _createElementVNode("div", _hoisted_4, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.datas, (val, vIndex) => {
                      return (_openBlock(), _createElementBlock(_Fragment, { key: vIndex }, [
                        (item.showData > vIndex)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                              _createElementVNode("img", {
                                class: "weather-icon",
                                src: val.url
                              }, null, 8, _hoisted_6),
                              _createElementVNode("div", _hoisted_7, [
                                _createElementVNode("div", _hoisted_8, _toDisplayString(val.text), 1),
                                _createElementVNode("div", _hoisted_9, _toDisplayString(val.value), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128)),
                    _createElementVNode("div", _hoisted_10, [
                      (item.showData == 99)
                        ? (_openBlock(), _createBlock(_component_van_icon, {
                            key: 0,
                            size: "15px",
                            onClick: ($event: any) => (_ctx.onClickMore(item)),
                            color: "#08af2a",
                            name: "arrow-up"
                          }, null, 8, ["onClick"]))
                        : (_openBlock(), _createBlock(_component_van_icon, {
                            key: 1,
                            size: "15px",
                            onClick: ($event: any) => (_ctx.onClickMore(item)),
                            color: "#08af2a",
                            name: "arrow-down"
                          }, null, 8, ["onClick"]))
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (item.sortType == 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("span", null, _toDisplayString(item.vrName), 1)
                  ]),
                  _createElementVNode("div", {
                    class: "content",
                    onClick: ($event: any) => (_ctx.onClickLand(item))
                  }, [
                    _createVNode(_component_van_image, {
                      fit: "cover",
                      src: 
                item.imgs[0]
                  ? item.imgs[0].url + '?imageView2/2'
                  : 'https://qnui.xfarmer.com/xfarmer-ui/trace/组 537@2x.png'
              ,
                      class: "bg"
                    }, null, 8, ["src"]),
                    _hoisted_14
                  ], 8, _hoisted_13)
                ]))
              : _createCommentVNode("", true),
            (item.sortType == 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("span", null, _toDisplayString(item.monitoringName), 1)
                  ]),
                  _createElementVNode("div", {
                    class: "content",
                    onClick: ($event: any) => (_ctx.onShowVideo(item))
                  }, [
                    _createVNode(_component_van_image, {
                      class: "bg",
                      fit: "cover",
                      src: 
                item.imgs[0]
                  ? item.imgs[0].url + '?imageView2/2'
                  : 'https://qnui.xfarmer.com/xfarmer-ui/trace/组 538@2x.png'
              
                    }, null, 8, ["src"]),
                    _hoisted_18
                  ], 8, _hoisted_17)
                ]))
              : _createCommentVNode("", true),
            (item.sortType == 2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("span", null, _toDisplayString(item.locationName), 1)
                  ]),
                  _createElementVNode("div", {
                    class: "map-pop",
                    onClick: _withModifiers(($event: any) => (_ctx.onClickMap(item)), ["prevent"])
                  }, null, 8, _hoisted_21),
                  _createElementVNode("div", {
                    id: 'mapContainer' + item.id,
                    style: {"position":"relative","z-index":"2"},
                    class: "content"
                  }, null, 8, _hoisted_22)
                ]))
              : _createCommentVNode("", true)
          ], 64))
        }), 128))
      ]),
      _: 1
    })
  ]))
}